// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","download":"download-3zwUy","logo":"logo-3DzJL","downloadIcon":"downloadIcon-SWODh","button":"button-3cKzs"};